import { PdfExportOptions } from '@app/pcs/shared/export-options/pdf-export-options/models/pdf-export-options';
import { Action } from '@ngrx/store';

export enum BulkExportActionTypes {
  ExportPdfBulk = '[BulkExport] Export PDF Bulk',
  ExportPdfBulkFail = '[BulkExport] Export PDF Bulk Fail'
}

export class ExportPdfBulk implements Action {
  readonly type = BulkExportActionTypes.ExportPdfBulk;

  constructor(public payload: PdfExportOptions) {
  }
}

export class ExportPdfBulkFail implements Action {
  readonly type = BulkExportActionTypes.ExportPdfBulkFail;

  constructor(public payload: Error) {
  }
}
